import { Theme } from '../mutation';

const themes = ['blue', 'teal','lightblue','cyan','orange','bluegray'];
const themesClass = ['blue', 'teal','lightblue','cyan','orange','bluegray'];    //需要与页面换色按钮同步
export default {
    state: {
        themeName: null,
        themeClass: null
    },
    mutations: {
        [Theme.CHANGE_THEME](state, val) {
            var index = themes.indexOf(val);
            if (index > -1) {
                state.themeName = val;
                state.themeClass = themesClass[index];
            }
        }
    },
    actions: {
        changeTheme({ commit }, themeName) {
            commit(Theme.CHANGE_THEME, themeName);
        }
    },
    getters: {
        themeName: state => {
            return state.themeName;
        },
        themeClass: state => {
            return state.themeClass;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/theme.js